import React from 'react';

const ViewToggle = ({ view, setView }) => (
  <div className="tvg-toolbar__view-toggle">
    <label className={view == 'grid' ? 'active' : ''} htmlFor="tvg-grid-view">
      <span className="icon-grid-view" />
      <input
        type="checkbox"
        id="tvg-grid-view"
        onClick={() => {
          setView(view, 'grid');
        }}
      />
    </label>
    <label className={view == 'list' ? 'active' : ''} htmlFor="tvg-list-view">
      <span className="icon-list-vertical" />
      <input
        type="checkbox"
        id="tvg-list-view"
        onClick={() => {
          setView(view, 'list');
        }}
      />
    </label>
    <label className={view == 'text' ? 'active' : ''} htmlFor="tvg-text-view">
      <span className="icon-accessibility" />
      <input
        type="checkbox"
        id="tvg-text-view"
        onClick={() => {
          setView(view, 'text');
        }}
      />
    </label>
  </div>
);

export default ViewToggle;
